import { customAxios, IDUSUARIO, USERNAME, FDV_URL } from '../constants';

const MENS_CAT_AUDIT = 'AUDIT_ERROR_WEB';
const MENS_NOM_AUDIT = 'FICHA_VENTA';
export default function(p_des_erro, p_Det_log, p_des_docu) {

  const data = {

  };

  const config = {
    params: {
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME,
      p_nom_cate: MENS_CAT_AUDIT,
      p_nom_obje: MENS_NOM_AUDIT,
      p_des_erro:p_des_erro,
      p_Det_log,
      p_des_docu,
    }
  };

  return customAxios.post(`${FDV_URL}/maestro/fichas-venta/loggerAuditoria`, data, config);
}



// WEBPACK FOOTER //
// ./src/utils/saveErrorUIComponent.js